module.exports = __webpack_public_path__ + "img/farming-by-numbers--cow.95b34af4.png";